import styled from 'vue-styled-components';

import { COLORS } from '../../../../colors';
import { FONTS } from '../../../../constants';

export const Container = styled.div`
  color: ${COLORS.DARK_GRAY};
  font-family: ${FONTS.ARIAL};
  font-size: 20px;
  flex-direction: column;
  display: flex;
  padding: 7px;
`;

export const Name = styled.span`
  font-weight: 600;
  text-transform: capitalize;
`;

export const Value = styled.span``;
